import { AxiosError } from 'axios';
import { QUERY_KEYS } from 'src/enums';
import { deleteCareerContent } from 'src/services/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const useDeleteCareerContent = () => {
  const client = useQueryClient();

  const { mutate, isLoading } = useMutation<{ success?: boolean }, AxiosError, { id: number }>(
    ['delete-career-content'],
    ({ id }) => deleteCareerContent(id),
    {
      onSuccess: () => {
        client.invalidateQueries([QUERY_KEYS.CAREER_CONTENT]);
      }
    }
  );

  return {
    mutate,
    isLoading
  };
};

export default useDeleteCareerContent;
